import React from 'react';
import { Link } from 'react-router-dom';

const ActionLogo = ({ isDark }) => (
  <div className="flex items-center">
    <Link to="/" className="group w-full cursor-pointer flex items-center">
      <img
        className="w-10 h-10 mr-2 lg:mr-4 bg-gradient-to-tr from-contrast1 to-contrast2
                        text-text1 rounded-3xl p-2"
        src={require('../../../assets/automako_logo.png')}
        alt="logo"
      />
      <span className={`${isDark ? 'text-bg3' : 'text-font1'} text-xl font-extrabold`}>AUTO</span>
      <span className="text-contrast2 text-xl font-extrabold">MAKO</span>
    </Link>
  </div>
);

export default ActionLogo;
